const steps = [
  {
    label: "See differently",
    body: "Every human arrives with another perspective, history, discipline, culture and way of noticing.",
  },
  {
    label: "Connect",
    body: "Those perspectives become more valuable when they enter into relationship.",
  },
  {
    label: "Create possibility",
    body: "Something can emerge between people that did not exist inside either person before.",
  },
];

const MechanismSection = () => {
  return (
    <section id="how-it-works" className="py-24 md:py-32 bg-muted/40 overflow-hidden">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center mb-16">
          <p className="text-sm uppercase tracking-[0.2em] text-coral-text mb-4">The mechanism</p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold">
            See differently, connect,{" "}
            <span className="text-gradient-coral">create possibility.</span>
          </h2>
        </div>

        <div className="relative">
          {/* organic thread behind the circles */}
          <svg
            className="hidden md:block absolute left-0 right-0 top-[72px] w-full text-primary/30"
            height="40"
            viewBox="0 0 1000 40"
            preserveAspectRatio="none"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M60 20 C 220 -14, 300 54, 500 20 C 700 -14, 780 54, 940 20"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeDasharray="5 6"
              className="mechanism-thread"
            />
          </svg>

          <div className="relative grid md:grid-cols-3 gap-12 md:gap-8">
            {steps.map((step, i) => (
              <div key={step.label} className="text-center">
                <div className="relative mx-auto mb-6 w-36 h-36 md:w-40 md:h-40">
                  <span
                    className="absolute inset-0 rounded-full bg-primary/10 animate-pulse-glow"
                    aria-hidden="true"
                  />
                  <span
                    className="absolute inset-2 rounded-full border border-primary/40"
                    aria-hidden="true"
                  />
                  <span className="absolute inset-0 flex flex-col items-center justify-center rounded-full bg-background/80">
                    <span className="text-xs tracking-[0.2em] text-muted-foreground">
                      0{i + 1}
                    </span>
                    <span className="mt-1 px-4 text-sm md:text-base font-heading font-bold leading-tight text-foreground">
                      {step.label}
                    </span>
                  </span>
                </div>
                <p className="text-muted-foreground leading-relaxed max-w-xs mx-auto">{step.body}</p>
              </div>
            ))}
          </div>
        </div>

        <p className="text-center text-xl md:text-2xl font-heading font-bold text-foreground mt-16">
          That is the Octopus Movement.
        </p>
      </div>
    </section>
  );
};

export default MechanismSection;